// Единая цветовая система типов мероприятий.
//
// background — очень светлый оттенок для фонов, линз и мягких свечений.
// card       — более заметный, но приглушённый оттенок для карточек мероприятий.
// accent     — спокойный пастельный акцент для чипов, границ
//              и декоративных элементов.
// ui         — более тёмный, приглушённый оттенок для заголовков,
//              иконок, кнопок, ссылок и других интерактивных элементов.

export const EVENT_TYPE_PALETTES = {
  conference: {
    background: '#E8F1F1',
    card: '#78A6A8',
    accent: '#8AAFB1',
    ui: '#3F686B'
  },

  seminar: {
    background: '#EEEAF4',
    card: '#9A8EB5',
    accent: '#A39ABB',
    ui: '#655D78'
  },

  symposium: {
    background: '#F0ECF5',
    card: '#A493B8',
    accent: '#B0A3C4',
    ui: '#6D607F'
  },

  workshop: {
    background: '#F5EBEF',
    card: '#BE8798',
    accent: '#C69FAA',
    ui: '#815F6C'
  },

  school: {
    background: '#E7F2F3',
    card: '#83B4BC',
    accent: '#91BFC5',
    ui: '#47757B'
  },

  congress: {
    background: '#E9F0F5',
    card: '#8FA9BE',
    accent: '#9DB4C8',
    ui: '#536E83'
  },

  forum: {
    background: '#EDEAF3',
    card: '#9C94B3',
    accent: '#A69FBD',
    ui: '#665E79'
  },

  roundtable: {
    background: '#E8F2EE',
    card: '#82AA9D',
    accent: '#98BBAE',
    ui: '#4D7267'
  },

  competition: {
    background: '#F5EFE7',
    card: '#B99A74',
    accent: '#C8AD8D',
    ui: '#80684D'
  },

  festival: {
    background: '#F4E9EC',
    card: '#B88A96',
    accent: '#C59BA5',
    ui: '#805D67'
  }
};


// Палитра по умолчанию,
// если тип мероприятия неизвестен или для него ещё нет отдельной схемы.

export const DEFAULT_EVENT_TYPE_PALETTE = {
  background: '#F0F4F4',
  card: '#8DA7A9',
  accent: '#9DB6B8',
  ui: '#526E71'
};


// Возвращает цветовую палитру конкретного типа мероприятия.

export const getEventTypePalette = (eventType, typeInfo) => {
  const palette = EVENT_TYPE_PALETTES[eventType];

  if (palette) {
    return palette;
  }

  // Если тип неизвестен, пытаемся использовать
  // существующий цвет типа из typeInfo.

  const fallbackColor =
    typeInfo?.color || DEFAULT_EVENT_TYPE_PALETTE.ui;

  return {
    ...DEFAULT_EVENT_TYPE_PALETTE,
    ui: fallbackColor
  };
};
